module.exports = __webpack_public_path__ + "img/about4.42f77c21.png";